import React, { useEffect, useState } from "react";
import { Breadcrumb, message, Spin } from "antd";
import { Link } from "react-router-dom";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import FilterComponent from "../components/filter.component";
import TableComponent from "../components/table.component";
import { axios, getToken, URL_API } from "../../../../utils";
import { getNumeral } from "../../../../utils/helper";

const PremiumContact = () => {
  const [filter, setFilter] = useState({
    status: "pending",
    limit: 10,
    page: 1,
  });
  const [dataSource, setDataSource] = useState();
  const [loading, setLoading] = useState(false);

  const callData = async (form) => {
    setLoading(true);
    try {
      const { page, limit, ...val } = form;
      const params = {
        ...val,
        limit,
        offset: (page - 1) * limit,
      };
      const res = await axios.get(`${URL_API}/premium-contact`, { params });
      setDataSource(res.data);
    } catch (error) {
      console.error(error);
      message.error("มีบางอย่างผิดพลาด");
    }
    setLoading(false);
  };

  const callComplete = async (id) => {
    try {
      await axios.post(
        `/premium-contact/${id}`,
        {},
        {
          baseURL: URL_API,
          headers: { Authorization: "Bearer " + getToken() },
        }
      );
      callData(filter);
      message.success("การอัปเดตเสร็จสิ้น");
    } catch (error) {
      console.error(error);
      message.error("มีบางอย่างผิดพลาด");
    }
  };

  useEffect(() => {
    filter && callData(filter);
  }, [filter]);

  return (
    <Spin spinning={loading}>
      <Breadcrumb className="mb-2">
        <Breadcrumb.Item>
          <Link to="/">หน้าหลัก</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>พรีเมียม Contacts</Breadcrumb.Item>
      </Breadcrumb>
      <Panel>
        <PanelHeader>พรีเมียม Contacts</PanelHeader>
        <PanelBody>
          <FilterComponent
            handleSubmit={(form) =>
              setFilter({ ...form.getFieldsValue(), limit: 10, page: 1 })
            }
          />
          <TableComponent
            dataSource={dataSource?.data || []}
            rowKey="id"
            pagination={{
              current: filter.page,
              pageSize: filter.limit,
              total: dataSource ? dataSource.total : 0,
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50", "100"],
              showLessItems: true,
              size: "default",
              showTotal: (total, range) =>
                `${getNumeral(range[0])} - ${getNumeral(
                  range[1]
                )} of ${getNumeral(total)}`,
              onChange: (current, pageSize) => {
                setFilter({ ...filter, limit: pageSize, page: current });
              },
              onShowSizeChange: (current, pageSize) =>
                setFilter({ ...filter, limit: pageSize, page: current }),
            }}
            callComplete={(id) => callComplete(id)}
          />
        </PanelBody>
      </Panel>
    </Spin>
  );
};

export default PremiumContact;
